import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Menu } from '../../models/menu.model';
import { Subscription } from 'rxjs/Subscription';
import { FrontService } from '../front.service';
import { ActivatedRoute, Router } from '@angular/router';

import { Slug } from 'ng2-slugify';
import { MalihuScrollbarModule, MalihuScrollbarService } from 'ngx-malihu-scrollbar';
import { Auth } from '../../models/auth.model';

import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
  group
} from '@angular/animations';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {
  subscription: Subscription;
  menus: Menu[];
  currentRoute: ActivatedRoute;
  defaultSubMenu = '';
  menuType = '';
  urlFragment = '';

  user = {
    ID: 1,
    name: 'John Doe',
    photo: 'assets/img/user_photo.jpg',
    email: 'johndoe@websiteblue.com',
    mobile: '+6112345678',
    telephone: '1234 5678',
    fax: '9876 5432'
  };

  authUser: Auth;

  isMultipleOffice = false;

  @ViewChild('sidebarBox') sidebarBox: ElementRef;
  @ViewChild('sidebarSubBox') sidebarSubBox: ElementRef;

  slug = new Slug(null);

  selectedLogo = '';

  constructor(public frontService: FrontService,
              private route: ActivatedRoute,
              private router: Router,
              private mScrollbarService: MalihuScrollbarService) { }

  ngOnInit() {
    this.authUser = this.frontService.authService.auth;

    if ( this.frontService.authService.getApp() === 'MyDesign3') {
      this.selectedLogo = 'mydesign-logo.svg';
    } else {
      if ( this.authUser.brandid === '6' ) {
        this.selectedLogo = 'Designplus_White.png';
      } else {
        this.selectedLogo = 'designly-logo-inverted.svg';
      }
    }

    if ( this.authUser.multiple.length > 1 ) {
      this.isMultipleOffice = true;
    }

    this.user = {
      ID: this.authUser.user.agent_id,
      name: this.authUser.user.firstname + ' ' + this.authUser.user.lastname,
      photo: this.authUser.user.imageurl,
      email: this.authUser.user.email,
      mobile: this.authUser.user.mobile,
      telephone: this.authUser.user.telephone,
      fax: this.authUser.user.fax
    };

    this.subscription = this.frontService.menuChanged.subscribe(
      (menus: Menu[]) => {
        this.menus = menus;
      }
    );

    this.frontService.routeData.subscribe(
      (data: any) => {
        this.currentRoute = data.route;
        this.urlFragment = '';
        this.defaultSubMenu = data.default;
        this.menuType = data.type;
      }
    );

  }

  nagivateLink(url) {
    this.router.navigate([], {relativeTo: this.currentRoute, fragment: url});
    this.urlFragment = url;
  }

  slugLink(link: string) {
    return this.slug.slugify((link).trim());
  }

  goToHelpPortal() {
    this.router.navigateByUrl('/help');
  }

  openTemplatesMenu() {
    $('.ul__sub-menu').css('display', 'block');
  }

  openTemplateSubMenu() {
    $('.ul__sub-menu').css('display', 'none');
  }

  ngAfterViewInit() {
    this.mScrollbarService.initScrollbar('#malihusb', { axis: 'y', theme: 'minimal', scrollInertia: 600 });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.mScrollbarService.destroy('#malihusb');
  }

}



// WEBPACK FOOTER //
// ./src/app/front/sidebar/sidebar.component.ts